import { render, staticRenderFns } from "./AdminMetadataUpdater.vue?vue&type=template&id=a5009b0a&scoped=true&"
import script from "./AdminMetadataUpdater.vue?vue&type=script&lang=ts&"
export * from "./AdminMetadataUpdater.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMetadataUpdater.vue?vue&type=style&index=0&id=a5009b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5009b0a",
  null
  
)

export default component.exports